import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import LicensingReport from "./LicensingReport";

function LicensingReportPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <LicensingReport />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default LicensingReportPage;
